import React from 'react';
import { NewModal as Modal, CompositeTable as Table, Button, themes } from '@digitools/honest-react';
import SubsLocsColumnModal from '../../../../Constants/SubsLocsColumns';
import { useDisclosure } from '@mantine/hooks';
const SubsAndLocsViewModal = ({ subsAndLocs }) => {
    const [isOpen, { open, close }] = useDisclosure(false);
    return (<>
      <Modal title={'View subsidiaries/locations'} centered={true} opened={isOpen} onClose={() => {
            close();
        }} cancelButtonText={'Close'} cancelButtonProps={{
            buttonType: 'primary',
            'aria-label': 'close view subsidiaries/locations modal'
        }} submitButton={false} theme={themes.rebrand} closeOnClickOutside={true}>
        <Table title={'subsidiary and location table'} data={subsAndLocs} defaultPageSize={10} columns={SubsLocsColumnModal} paginated={true} theme={themes.rebrand} filterable={true} isSelectable={false} rowIdentifier={'locationId'} data-testid={'subLocTable'}/>
      </Modal>
      <Button buttonType={'text'} type={'button'} onClick={open}>
        View subsidiaries/locations
      </Button>
    </>);
};
export default SubsAndLocsViewModal;
